import DefaultElementNodeType from '../DefaultElementNodeType';
import {APPLICATION_SERVICE} from '../../metamodel/Concept';

export default class ApplicationServiceNodeType extends DefaultElementNodeType {
	static get typeName() {
		return APPLICATION_SERVICE;
	}
}
